<template>
  <v-footer class="pt-6 pt-md-16 pb-0 d-flex flex-column" color="surface-light">
    <v-row class="w-75">
      <v-col
        cols="12"
        lg="4"
        md="12"
        class="d-flex flex-column align-center"
      >

        <svg-logo-text width="100%" />
        <img :src="theme.current.value.dark ? MadeAndHostedInEuropeDark : MadeAndHostedInEurope" alt="MadeAndHostedInEurope" class="mt-8" width="150" />
      </v-col>

      <v-col
        v-for="(section, i) in sections"
        :key="i"
        cols="6"
        lg="4"
        md="6"
        class="text-center text-lg-left"
      >
        <p class="text-body-large font-weight-bold mb-3">{{ section.title }}</p>

        <div
          v-for="item in section.items"
          :key="item.text"
        >
          <v-btn
            class="text-none px-0 justify-start footer-link"
            exact
            :href="item.href"
            :to="item.to"
            :ripple="false"
            :text="item.text"
            :target="item.href ? '_blank' : undefined"
            :rel="item.href ? 'noopener noreferrer' : undefined"
            :append-icon="item.href ? 'mdi-open-in-new' : undefined"
            variant="plain"
          />
        </div>
      </v-col>
    </v-row>
    <v-divider class="my-6" />
  </v-footer>
</template>

<script setup>
import MadeAndHostedInEurope from '@/public/static/europe/made_and_hosted_in_europe.svg'
import MadeAndHostedInEuropeDark from '@/public/static/europe/made_and_hosted_in_europe_dark.svg'

const theme = useTheme()

const sections = [
  {
    title: 'SysLeaks',
    items: [
      { text: 'Pricing', to: '/pricing' },
      { text: 'FAQs', to: '/faqs' },
      { text: 'Sign up', to: '/signup' },
    ],
  },
  {
    title: 'Legal',
    items: [
      { text: 'Privacy Notice', to: '/data-privacy' },
      { text: 'SysLeaks "Free" ToS', to: '/api/v1/documents/latest?type=free-tos' },
      { text: 'Imprint', href: 'https://www.syslifters.com/en/imprint' },
      { text: 'Contact us', href: 'https://docs.syslifters.com/en/contact-us/' },
    ],
  },
]
</script>

<style lang="scss" scoped>

.footer-link :deep(.v-btn__append) {
  font-size: 10px;
}

.footer-link,
.footer-link:visited,
.v-btn,
.v-btn:visited {
  color: rgb(var(--v-theme-primary));
  font-weight: 500;
  opacity: 1;
}
</style>
